export const ErrorLevels = Object.freeze({
  Information: 0,
  Warning: 1,
  Error: 2,
  Success: 3,
});
